<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <!--    강서구청-->
    <div v-if="hostname === 'bsgs.maot.co.kr'" class="vx-col">
      <img src="@/assets/images/pages/login_bsgs.svg" style="position: absolute; left: 60px; top: 48px; width: 100%; max-width: 180px" />
      <div class="w-full text-left" style="margin-bottom: 36px">
        <img src="@/assets/images/pages/login_bsgs_2.svg" alt="login" style="width: 100%; max-width: 340px" />
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center grid grid-cols-1 md:grid-cols-12" style="max-width: 1150px">
            <!--              style="display: grid; grid-template-columns: 550px 620px; grid-template-rows: 400px;">-->
            <div class="vx-col hidden md:block col-span-7" style="height: 100%; width: 100%">
              <img src="@/assets/images/pages/login_bsgs_left.jpg" style="width: 640px; height: 100%; max-height: 440px; object-fit: cover" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-5" style="padding: 40px 0px">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4" style="font-size: 26px">로그인</h4>
                  <p style="font-size: 17px">아이디와 비밀번호를 입력해주세요.</p>
                </div>

                <div class="pt-1">
                  <ml-input name="email" icon-no-border icon-pack="feather" placeholder="아이디 입력" v-model="emailInput" :danger="emailRules" class="w-full input-font" />

                  <ml-input type="password" name="password" icon-no-border icon-pack="feather" placeholder="비밀번호 입력" v-model="passwordInput" class="w-full mt-1 input-font" @keyup.enter="login" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 기억하기</vs-checkbox>
                    <!--                    <router-link to="/forgot-password">비밀번호를 잊으셨나요?</router-link>-->
                  </div>
                  <!--
                  # 자동방지문자 : google
                  -->

                  <vue-recaptcha v-if="recaptcha" class="mb-8" ref="recaptcha" @expired="onExpired" @render="cargarCaptchar = true" @error="recaptchar = false" @verify="onVerify" sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU" />

                  <vs-button v-if="isLoginInProgress" class="float-right" color="secondary" disabled>잠시만 기다려주세요</vs-button>
                  <vs-button v-else class="float-right" color="secondary" @click="login">로그인</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="w-full text-center" style="margin-top: 38px">
        <img src="@/assets/images/pages/login_bsgs_slogan.svg" alt="login" style="width: 100%; max-width: 630px" />
      </div>
    </div>

    <div v-else-if="hostname === 's1.maot.co.kr'" class="vx-col">
      <img src="@/assets/images/pages/s1_ci.svg" style="position: absolute; left: 60px; top: 48px; width: 100%; max-width: 180px" />
      <div class="w-full text-left" style="margin-bottom: 36px">
        <img src="@/assets/images/pages/s1_Slogan.svg" alt="login" style="width: 100%; max-width: 340px" />
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center grid grid-cols-1 md:grid-cols-12" style="max-width: 1150px">
            <!--              style="display: grid; grid-template-columns: 550px 620px; grid-template-rows: 400px;">-->
            <div class="vx-col hidden md:block col-span-7" style="height: 100%; width: 100%">
              <img src="@/assets/images/pages/busan.png" style="width: 640px; height: 100%; max-height: 440px; object-fit: cover" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-5" style="padding: 40px 0px">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4" style="font-size: 26px">로그인</h4>
                  <p style="font-size: 17px">아이디와 비밀번호를 입력해주세요.</p>
                </div>

                <div class="pt-1">
                  <ml-input name="email" icon-no-border icon-pack="feather" placeholder="아이디 입력" v-model="emailInput" :danger="emailRules" class="w-full input-font" />

                  <ml-input type="password" name="password" icon-no-border icon-pack="feather" placeholder="비밀번호 입력" v-model="passwordInput" class="w-full mt-1 input-font" @keyup.enter="login" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 기억하기</vs-checkbox>
                    <!--                    <router-link to="/forgot-password">비밀번호를 잊으셨나요?</router-link>-->
                  </div>
                  <!--
                  # 자동방지문자 : google
                  -->

                  <vue-recaptcha v-if="recaptcha" class="mb-8" ref="recaptcha" @expired="onExpired" @render="cargarCaptchar = true" @error="recaptchar = false" @verify="onVerify" sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU" />

                  <vs-button v-if="isLoginInProgress" class="float-right" color="secondary" disabled>잠시만 기다려주세요</vs-button>
                  <vs-button v-else class="float-right" color="secondary" @click="login">로그인</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

<!--    동국제강-->
    <div v-else-if="hostname === 'dksteel.maot.co.kr'" class="vx-col">
      <img src="@/assets/images/pages/login_dksteel.svg" style="position: absolute; left: 60px; top: 48px; width: 100%; max-width: 180px" />
      <div class="w-full text-left" style="margin-bottom: 36px; text-align-last: center;">
        <img src="@/assets/images/pages/login_dksteel.svg" alt="login" style="width: 100%; max-width: 340px" />
        <h1 class="mt-1">'일하는 모든 사람들의 안전과 건강을 지키는 기업'</h1>
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center grid grid-cols-1 md:grid-cols-12" style="max-width: 1150px">
            <!--              style="display: grid; grid-template-columns: 550px 620px; grid-template-rows: 400px;">-->
            <div class="vx-col hidden md:block col-span-6" style="height: 100%; width: 100%">
              <img src="@/assets/images/pages/dksteel.png" style="width: 550px; height: 100%; max-height: 440px; object-fit: cover" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-6" style="padding: 40px 0px">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4" style="font-size: 26px">로그인</h4>
                  <p style="font-size: 17px">아이디와 비밀번호를 입력해주세요.</p>
                </div>

                <div class="pt-1">
                  <ml-input name="email" icon-no-border icon-pack="feather" placeholder="아이디 입력" v-model="emailInput" :danger="emailRules" class="w-full input-font" />

                  <ml-input type="password" name="password" icon-no-border icon-pack="feather" placeholder="비밀번호 입력" v-model="passwordInput" class="w-full mt-1 input-font" @keyup.enter="login" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 기억하기</vs-checkbox>
                    <!--                    <router-link to="/forgot-password">비밀번호를 잊으셨나요?</router-link>-->
                  </div>
                  <!--
                  # 자동방지문자 : google
                  -->

                  <vue-recaptcha v-if="recaptcha" class="mb-8" ref="recaptcha" @expired="onExpired" @render="cargarCaptchar = true" @error="recaptchar = false" @verify="onVerify" sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU" />

                  <vs-button v-if="isLoginInProgress" class="float-right" color="secondary" disabled>잠시만 기다려주세요</vs-button>
                  <vs-button v-else class="float-right" color="secondary" @click="login">로그인</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <!-- 국토안전관리원-->
    <div v-else-if="hostname === 'kalis.maot.co.kr' || hostname === 'localhost'" class="vx-col">
      <img src="@/assets/images/pages/kalis_login_slogan.svg" style="position: absolute; left: 60px; top: 48px; width: 100%; max-width: 371px" />
      <img src="@/assets/images/pages/kalis_login_emblem.svg" style="position: absolute; right: 40px; bottom: 40px; width: 100%; max-width: 100px" />
      <div class="w-full text-center" style="margin-bottom: 36px">
        <img src="@/assets/images/pages/kalis_login_logo.svg" alt="login" style="width: 100%; max-width: 340px" />
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center grid grid-cols-1 md:grid-cols-12" style="max-width: 1150px">
            <!--              style="display: grid; grid-template-columns: 550px 620px; grid-template-rows: 400px;">-->
            <div class="vx-col hidden md:block col-span-6" style="height: 100%; width: 100%">
              <img src="@/assets/images/pages/kalis_login_image.png" style="width: 550px; height: 100%; max-height: 440px; object-fit: cover" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-6" style="padding: 40px 0px">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4" style="font-size: 26px">로그인</h4>
                  <p style="font-size: 17px">아이디와 비밀번호를 입력해주세요.</p>
                </div>

                <div class="pt-1">
                  <ml-input name="email" icon-no-border icon-pack="feather" placeholder="아이디 입력" v-model="emailInput" :danger="emailRules" class="w-full input-font" />

                  <ml-input type="password" name="password" icon-no-border icon-pack="feather" placeholder="비밀번호 입력" v-model="passwordInput" class="w-full mt-1 input-font" @keyup.enter="login" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 기억하기</vs-checkbox>
                    <!--                    <router-link to="/forgot-password">비밀번호를 잊으셨나요?</router-link>-->
                  </div>
                  <!--
                  # 자동방지문자 : google
                  -->

                  <vue-recaptcha v-if="recaptcha" class="mb-8" ref="recaptcha" @expired="onExpired" @render="cargarCaptchar = true" @error="recaptchar = false" @verify="onVerify" sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU" />

                  <vs-button v-if="isLoginInProgress" class="float-right" color="secondary" disabled>잠시만 기다려주세요</vs-button>
                  <vs-button v-else class="float-right" color="secondary" @click="login">로그인</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <!--    그외 -->
    <div v-else class="vx-col">
      <div class="w-full text-center" style="margin-bottom: 64px">
        <img v-if="hostname === 'ep.maot.co.kr'" src="@/assets/images/pages/ep-login.svg" alt="login" style="width: 100%; max-width: 450px; max-height: 160px" />
        <img v-else-if="hostname === 'dgjg.maot.co.kr'" src="@/assets/images/pages/dgjg-login.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else-if="hostname === 'gsnd.maot.co.kr'" src="@/assets/images/pages/login_gsnd.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else-if="hostname === 'gjng.maot.co.kr'" src="@/assets/images/pages/gjn-login.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else-if="hostname === 'gdco.maot.co.kr'" src="@/assets/images/pages/gdco-login.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else-if="hostname === 'publicdemo.maot.co.kr'" src="@/assets/images/pages/public-login.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else-if="hostname === 'kangwonlanddemo.maot.co.kr'" src="@/assets/images/pages/kangwonland-login.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else-if="hostname === 'premium.maot.kr'" src="@/assets/images/pages/login_Premuim.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else-if="hostname === 'dbm.maot.kr'" src="@/assets/images/pages/MAOT_DB_Management_System_login.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else-if="hostname === 'dksteel.maot.kr'" src="@/assets/images/pages/login_dksteel.svg" alt="login" style="width: 100%; max-width: 450px" />
        <img v-else src="@/assets/images/pages/MAOT_DB_Management_System_login.svg" alt="login" style="width: 100%; max-width: 450px; max-height: 160px" />
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center grid grid-cols-7 md:grid-cols-12" style="max-width: 1150px">
            <!--              style="display: grid; grid-template-columns: 550px 620px; grid-template-rows: 400px;">-->
            <div class="vx-col hidden md:block col-span-5" style="height: 100%; width: 100%">
              <img src="@/assets/images/pages/login2.svg" style="width: 100%; height: 100%; object-fit: cover" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-7" style="padding: 40px 0px">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">로그인</h4>
                  <p>아이디와 비밀번호를 입력해주세요.</p>
                </div>

                <div class="pt-1">
                  <ml-input name="email" icon-no-border icon="icon icon-user" icon-pack="feather" label-placeholder="아이디 입력" v-model="emailInput" :danger="emailRules" class="w-full" />

                  <ml-input type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather" label-placeholder="비밀번호 입력" v-model="passwordInput" class="w-full mt-6" @keyup.enter="login" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 기억하기</vs-checkbox>
                    <!--                    <router-link to="/forgot-password">비밀번호를 잊으셨나요?</router-link>-->
                  </div>
                  <!--
                  # 자동방지문자 : google
                  -->

                  <vue-recaptcha v-if="recaptcha" class="mb-8" ref="recaptcha" @expired="onExpired" @render="cargarCaptchar = true" @error="recaptchar = false" @verify="onVerify" sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU" />

                  <vs-button v-if="isLoginInProgress" class="float-right" color="secondary" disabled>잠시만 기다려주세요</vs-button>
                  <vs-button v-else class="float-right" color="secondary" @click="login">로그인</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import config from "/public/config";
import VueCookie from "vue-cookie";
import constant from "@/constant/constant";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    VueRecaptcha,
  },
  watch: {
    checkbox_remember_me(checkbox_remember_me) {
      this.checkbox_remember_me = checkbox_remember_me;
      VueCookie.set("login_remember_me", checkbox_remember_me, 30);

      if (!this.checkbox_remember_me) {
        VueCookie.set("login_remember_email", "");
      }
    },
  },
  data() {
    return {
      hostname: config.HOST_NAME,
      emailInput: "",
      passwordInput: "",
      checkbox_remember_me: false,
      recaptcha: false,
      recaptchaValue: "",
      isLoginInProgress: false, // 로그인 진행중인지 여부
    };
  },
  computed: {
    emailRules() {
      return this.checkEmailRule(this.emailInput);
    },
  },
  created() {
    this.checkbox_remember_me = VueCookie.get("login_remember_me") === "true";
    if (this.checkbox_remember_me) {
      this.emailInput = VueCookie.get("login_remember_email") ? VueCookie.get("login_remember_email") : "";
    }
  },
  methods: {
    onVerify(r) {
      this.recaptchaValue = r;
      this.recaptcha = true;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },

    handleChangeRememberMe(/*data*/) {},
    checkEmailRule(v) {
      if (v === "") {
        return true;
      }

      const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
      return !regExp.test(v);
    },

    async login() {
      if (this.isLoginInProgress) return;

      const email = this.emailInput;
      const pw = this.passwordInput;
      const rcv = this.recaptchaValue;

      if (!email) {
        alert("아이디를 입력해주세요");
        return;
      }
      if (email.length < 3) {
        alert("아이디는 3글자 이상이어야 합니다.");
        return;
      }

      if (!pw) {
        alert("비밀번호를 입력해주세요");
        return;
      }

      // 비밀번호가 8자 이상, 소문자, 대문자, 숫자가 포함되어있는지 검증
      // if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,255}$/.test(pw)) {
      //   alert("비밀번호는 8자 이상, 소문자, 대문자, 숫자가 포함되어야 합니다.");
      //   return;
      // }

      this.isLoginInProgress = true;

      this.$store
        .dispatch("LOGIN", {
          email,
          pw,
          rcv,
        })
        .then(() => {
          if (VueCookie.get("login_remember_me") === "true") {
            VueCookie.set("login_remember_email", this.emailInput, 30);
          }

          localStorage.setItem("login_username", email);

          // 프로젝트 개수만큼 삭제해야함.
          // 지금은 임의로 10개 삭제하도록 설정
          for (let i = 0; i < 10; i++) {
            localStorage.removeItem(`${email}_${i + 1}_boardIds`);
          }
          localStorage.removeItem("/api/auth/me");
          localStorage.removeItem("/api/v1/member/all");
          localStorage.removeItem("sub_company");

          const toFullPath = VueCookie.get("LOGIN_TO_FULLPATH")
          if (toFullPath) {
            this.$router.replace(toFullPath).then((value) => {
              VueCookie.delete('LOGIN_TO_FULLPATH') // 로그인 후 이동할 페이지 삭제
              this.$router.go(0);
            });
          } else {
            this.$router.replace("/home").then((value) => {
              this.$router.go(0);
            });
          }
        })
        .catch((err) => {
          if (this.recaptcha) {
            this.$refs.recaptcha.reset();
          }

          switch (constant.getErrorCode(err)) {
          case constant.ERROR_LOGIN_ID_NULL:
            alert("아이디를 입력해주세요");
            break;
          case constant.ERROR_LOGIN_PASSWORD_NULL:
            alert("비밀번호를 입력해주세요");
            break;
          case constant.ERROR_LOGIN_INVALID_CREDENTIALS:
            alert("아이디 또는 패스워드가 틀립니다");
            break;
          case constant.ERROR_LOGIN_INVALID_RECAPTCHA:
            this.recaptcha = true;
            break;
          case -1:
            switch (err.response.data) {
            case "The login must be between 2 and 255 characters.":
              alert("아이디는 2자 이상 255자 이하로 입력해주세요.");
              break;
            case "The password must be between 4 and 255 characters.":
              alert("비밀번호는 4자 이상 255자 이하로 입력해주세요.");
              break;
            default:
              alert(err.response.data);
              break;
            }
            break;
          }
          this.isLoginInProgress = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
.input-font::v-deep {
  span {
    font-size: 16px !important;
    height: 100%;
  }
  input {
    font-size: 16px !important;
  }
}
</style>
